import React, { useEffect } from "react";
import queryClient from "../../utils/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Theme } from "@radix-ui/themes";
import { useKonamiCode } from "../../utils/useKonamiCode";
import Header from "./components/Header";
import Footer from "./components/Footer";
import "../../assets/stylesheets/global.css";
import { VehicleCompareProvider } from "../../utils/VehicleCompareProvider";
import VehicleComparator from "../VehicleComparator.tsx";
import { usePage } from "@inertiajs/react";

const HomeLayout = ({
  children,
  comparatorIds,
  blogHasArticles,
}: {
  children: React.ReactNode;
  comparatorIds: string[];
  blogHasArticles: boolean;
}) => {
  const success = useKonamiCode();
  const { url } = usePage();

  useEffect(() => {
    if (success) {
      document.body.classList.add("easter-egg");
    }
    return () => {
      document.body.classList.remove("easter-egg");
    };
  }, [success]);

  const isReviewNewPage = url.includes("/reviews/new");

  return (
    <QueryClientProvider client={queryClient}>
      <VehicleCompareProvider defaultValue={comparatorIds}>
        <Theme>
          <Header
            showEvaluationButton={!isReviewNewPage}
            showBlogLink={blogHasArticles}
          />
          <div className="flex flex-col gradient-bg">{children}</div>
          <Footer showShareExperienceBlock={!isReviewNewPage} />
          <ReactQueryDevtools
            initialIsOpen={false}
            buttonPosition="bottom-left"
          />
        </Theme>
        <VehicleComparator />
      </VehicleCompareProvider>
    </QueryClientProvider>
  );
};

export default HomeLayout;
